// /src/root/root.jsx
import React from 'react';
import './root.css';
import Sidebar from "../sidebar/sidebar";

function Root() {
  return (
    <div className="root">
      <Sidebar />
    </div>
  );
}

export default Root;
